import { custom } from './custom';

export const environment = {
	...custom,
	name: 'Development',
	api_url: 'https://deve-dashboard-welex.prov.bz.it/dbe',
	readylex_url: 'https://deve-dashboard-welex.prov.bz.it/simplex',
	msalConfig: {
		clientId: '6060923f-9f55-4574-8bd8-e2b46dda7b1d',
		authority:
			'https://testb2c01siag.b2clogin.com/testb2c01siag.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN_SPID',
		knownAuthorities: ['testb2c01siag.b2clogin.com'],
		scopes: [
			'https://testb2c01siag.onmicrosoft.com/18d5c0c5-2577-4d98-b511-180f92639cc0/api.read',
		],
		extraQueryParameters: { authLogin: 'aad' },
	},
};
